import { z } from 'zod';
import { apiRequest } from './masterdata/repository';
import { workflowValue } from './workflows/repository';
const occurrence = z
  .object({
    id: z.string(),
    warning_code: z.string(),
    reason_code: z.string(),
    source_module: z.string(),
    source_type: z.string(),
    source_id: z.string(),
    subject: z.record(z.unknown()),
    detail: z.record(z.unknown()),
    responsible_role: z.string(),
    status: z.enum(['open', 'acknowledged', 'cleared']),
    raised_at: z.string(),
    read: z.boolean().optional(),
    source_action_required: z.string().nullable().optional(),
    acknowledged_by: z.string().nullable().optional(),
    acknowledged_at: z.string().nullable().optional(),
    acknowledgement_note: z.string().nullable().optional(),
    cleared_at: z.string().nullable().optional(),
    cleared_reason: z.string().nullable().optional(),
  })
  .passthrough();
export type WarningOccurrence = z.infer<typeof occurrence>;
const page = z.object({
  data: z.array(occurrence),
  total: z.number(),
  page: z.number(),
  page_size: z.number(),
  unread_count: z.number(),
});
export async function warningList(query: URLSearchParams, admin: boolean, signal?: AbortSignal) {
  return page.parse(
    await apiRequest(
      `${admin ? '/admin/warnings' : '/warnings/inbox'}?${query}`,
      'GET',
      undefined,
      signal
    )
  );
}
export async function warningDetail(id: string, signal?: AbortSignal) {
  return occurrence.parse(
    await apiRequest(`/warnings/${encodeURIComponent(id)}`, 'GET', undefined, signal)
  );
}
export async function warningCount(signal?: AbortSignal) {
  return z
    .object({ unread_count: z.number() })
    .parse(await apiRequest('/warnings/inbox/unread-count', 'GET', undefined, signal)).unread_count;
}
export async function warningAction(id: string, action: 'read' | 'acknowledge', note?: string) {
  const result = await apiRequest(
    `/warnings/${encodeURIComponent(id)}/${action}`,
    'POST',
    action === 'read' || !note ? {} : { note }
  );
  window.dispatchEvent(new Event('nissei-warnings-refresh'));
  return workflowValue(result);
}
export async function runWarningChecks() {
  return workflowValue(await apiRequest('/warnings/check', 'POST', {}));
}
